import { Modal } from 'almanac-ui/Modal'
import Styles from './MoveConfirmationModal.module.scss'
import { MoveConfirmationModalProps } from './Types'
import { Button } from 'components/Button'
import { FileMoveAttemptResult } from 'api/FileMoveAttemptsClient'

const MoveConfirmationModal = ({
  closeModal,
  onSubmit,
  fileMoveAttemptResult,
  newParentFolderTitle,
}: MoveConfirmationModalProps) => {
  const title =
    fileMoveAttemptResult === FileMoveAttemptResult.PermissionsWillChange
      ? 'Change access?'
      : 'Change access and status?'

  const content = () => {
    if (fileMoveAttemptResult === FileMoveAttemptResult.PermissionsWillChange) {
      return <span>{`Everyone with access to "${newParentFolderTitle}" will now have access.`}</span>
    }

    if (fileMoveAttemptResult === FileMoveAttemptResult.WorkflowExistsOnCurrentFolder) {
      return (
        <span>
          {`Everyone with access to ${newParentFolderTitle} will now have access and document statuses will be updated.`}
        </span>
      )
    }

    if (fileMoveAttemptResult === FileMoveAttemptResult.ActiveReviewWithinCurrentFolder) {
      return (
        <ul className={Styles.listWithBullets}>
          <li>{`Everyone with access to "${newParentFolderTitle}" will now have access.`}</li>
          <li>Document statuses will be updated.</li>
          <li>Any active Reviews will be ended.</li>
        </ul>
      )
    }
  }

  return (
    <Modal.Root>
      <Modal.Header title={title} />
      <Modal.Content>{content()}</Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button
            size="lg"
            onPress={() => {
              closeModal()
              onSubmit()
            }}
          >
            Confirm
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { MoveConfirmationModal }
